import { render, staticRenderFns } from "./List.vue?vue&type=template&id=b3de513a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.44.2__css-load_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3de513a",
  null
  
)

export default component.exports